import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { FiAlertCircle } from "react-icons/fi";
import {
  GRAY_LIGHT,
  REDMONEDD,
  WHITE,
} from "../../../../constants/colors";
import { toast } from "react-toastify";
import VendasRecorrentesApi from "../../../../services/vendasRecorrentesApi";

const ModalCancelamentoAssinatura = ({ isOpen, setIsOpen, id }: any) => {
  const finalRef = React.useRef(null);

  console.log("id", id);

  const onClose = () => {
    setIsOpen(false);
  };

  async function CancelarAssinatura() {
    try {
      const response = await VendasRecorrentesApi.deleteVendaRecorrente(id);
      toast.success("Assinatura Cancelada com Sucesso!");
      setIsOpen(false);
    } catch (error: any) {
      console.log("error:", error);
      toast.error(
        error?.response?.data || "Não foi possível cancelar a assinatura!"
      );
    }
  }

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size={"xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            w={"100%"}
            h={"110px"}
          >
            {<FiAlertCircle color={REDMONEDD} size={70} />}
          </Box>
          <ModalBody>
            <Box
              h={"70px"}
              justifyContent={"center"}
              textAlign={"center"}
              alignContent={"center"}
            >
              <Text fontSize="2xl">Deseja cancelar esta assinatura?</Text>
            </Box>
          </ModalBody>

          <ModalFooter justifyContent={"space-evenly"}>
            <Button
              background={GRAY_LIGHT}
              mr={3}
              onClick={() => {
                onClose();
              }}
            >
              Fechar
            </Button>
            <Button
              background={REDMONEDD}
              color={WHITE}
              onClick={() => {
                CancelarAssinatura();
                onClose();
              }}
            >
              Efetuar Cancelamento
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalCancelamentoAssinatura;
